import {
  HELP_CENTER_PATH,
  HELP_CENTER_TICKETS_PATH,
} from "@/features/helpCenter/configs/helpCenterPaths.config";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const TicketsPage = lazyWithRetry(() =>
  import("@/features/tickets/pages/TicketsPage").then((m) => ({ default: m.TicketsPage })),
);
const TicketDetailPage = lazyWithRetry(() => import("@/features/tickets/pages/TicketDetailPage"));

export const HELP_PATH = HELP_CENTER_PATH;
export const TICKETS_PATH = HELP_CENTER_TICKETS_PATH;
export const TICKET_DETAIL_PATH = `${HELP_PATH}/ticket/:ticketId`;

export const buildTicketDetailPath = (ticketId: string) => TICKET_DETAIL_PATH.replace(":ticketId", ticketId);

const ticketsRoutes: RouteConfig[] = [
  {
    path: TICKETS_PATH,
    element: <TicketsPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: TICKET_DETAIL_PATH,
    element: <TicketDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default ticketsRoutes;
